// This is the single source of truth for which image formats we accept and what we tell a user
// when we do not.
export const SUPPORTED_IMAGE_FORMATS = Object.freeze(['avif', 'gif', 'jpeg', 'png', 'svg', 'webp']);
export const SUPPORTED_LIST_MESSAGE = 'Please upload a JPEG, PNG, GIF, WebP, or SVG image.';
export const UNSUPPORTED_IMAGE_MESSAGE = `That image format is not supported. ${SUPPORTED_LIST_MESSAGE}`;
export const UNSUPPORTED_HEIC_MESSAGE = 'HEIC/HEIF images are not supported. Please convert the photo to JPEG or PNG and try again.';
// For the `accept` attribute on file inputs. Only a picker hint, it is not enforcement, and
// drag-and-drop bypasses it entirely, so never rely on it alone.
export const IMAGE_ACCEPT_ATTRIBUTE = 'image/png, image/jpeg, image/gif, image/webp, image/avif, image/svg+xml';
const UNSUPPORTED_IMAGE_TYPE_PATTERN = /^image\/(bmp|x-bmp|x-ms-bmp|tiff|x-icon|vnd\.microsoft\.icon)$/;
const UNSUPPORTED_IMAGE_EXTENSION_PATTERN = /\.(bmp|tiff?|ico)$/i;
const HEIC_TYPE_PREFIXES = ['image/heic', 'image/heif'];
const HEIC_EXTENSION_PATTERN = /\.hei[cf]$/i;
export const unsupportedImageMessage = (file) => {
    const type = (file?.type || '').toLowerCase();
    const name = file?.name || '';
    if (HEIC_TYPE_PREFIXES.some((prefix) => type.startsWith(prefix)) ||
        HEIC_EXTENSION_PATTERN.test(name)) {
        return UNSUPPORTED_HEIC_MESSAGE;
    }
    if (UNSUPPORTED_IMAGE_TYPE_PATTERN.test(type) || UNSUPPORTED_IMAGE_EXTENSION_PATTERN.test(name)) {
        return UNSUPPORTED_IMAGE_MESSAGE;
    }
    return null;
};
//# sourceMappingURL=index.js.map